var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "trophy_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4h56v22.909h-5.09V9.09h-5.092v17.818c0 8.53-5.994 15.66-14 17.408v8.047h14V60H14.182v-7.636h14v-8.047c-8.006-1.748-14-8.878-14-17.408V9.09H9.09v17.818H4z",
    clipRule: "evenodd"
  })));
};
export { SvgTrophy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMy45OTk3Nkg2MFYyNi45MDg4SDU0LjkwOTFWOS4wOTA2Nkg0OS44MTgyVjI2LjkwODhDNDkuODE4MiAzNS40Mzg5IDQzLjgyNDEgNDIuNTY5IDM1LjgxODIgNDQuMzE3VjUyLjM2MzlINDkuODE4MlY2MC4wMDAzSDE0LjE4MThWNTIuMzYzOUgyOC4xODE4VjQ0LjMxN0MyMC4xNzU5IDQyLjU2OSAxNC4xODE4IDM1LjQzODkgMTQuMTgxOCAyNi45MDg4VjkuMDkwNjZIOS4wOTA5MVYyNi45MDg4SDRWMy45OTk3NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";